var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParentAgencyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19.2,
    viewBox: "0 0 24 19.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hands-holding-child-solid",
    d: "M12,0a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12,0Zm1.676,6.161.416,3.326a.9.9,0,0,1-1.785.225L12.143,8.4h-.285l-.165,1.312a.9.9,0,1,1-1.785-.225l.416-3.33-.743.63A.9.9,0,1,1,8.419,5.415L9.465,4.53a3.926,3.926,0,0,1,5.07,0l1.046.885a.9.9,0,0,1-1.163,1.372l-.743-.626ZM1.5,2.4A1.5,1.5,0,0,1,3,3.9V9.908a2.4,2.4,0,0,0,.7,1.7l1.916,1.916a.92.92,0,1,0,1.3-1.3l-.57-.57-1.2-1.2a1.2,1.2,0,0,1,1.7-1.7l1.2,1.2.57.57h0l.949.949a4.2,4.2,0,0,1,1.23,2.97V17.4A1.8,1.8,0,0,1,9,19.2H6.5a2.4,2.4,0,0,1-1.7-.7L1.054,14.752A3.6,3.6,0,0,1,0,12.206V3.9A1.5,1.5,0,0,1,1.5,2.4Zm21,0A1.5,1.5,0,0,1,24,3.9v8.306a3.6,3.6,0,0,1-1.054,2.546L19.2,18.5a2.4,2.4,0,0,1-1.7.7H15a1.8,1.8,0,0,1-1.8-1.8V14.441a4.2,4.2,0,0,1,1.23-2.97l.949-.949h0l.57-.57,1.2-1.2a1.2,1.2,0,0,1,1.7,1.7l-1.2,1.2-.57.57a.92.92,0,1,0,1.3,1.3l1.916-1.916a2.4,2.4,0,0,0,.7-1.7V3.9a1.5,1.5,0,0,1,1.5-1.5Z",
    fill: "#c9c9c9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentAgencyIcon);
export default __webpack_public_path__ + "static/media/parent-agency-icon.0b8c1b19d4964d982d55ec6b6615148e.svg";
export { ForwardRef as ReactComponent };